'use client';

import React, { ReactNode, useEffect } from 'react';
import { initializeMsal } from '@/utils/msalInstance';

interface AuthProviderProps {
    children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
    useEffect(() => {
        initializeMsal().catch(() => {});
    }, []);

    return (
        <>
            {children}
        </>
    );
}
